module.exports = __webpack_public_path__ + "static/media/anc6kz.75778905.pdf";